var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-dark py-2 mb-4 top-space",attrs:{"id":"AdminHeader"}},[_c('h1',{staticClass:"text-white"},[_vm._v("Admin Dashboard")])])}]

export { render, staticRenderFns }